import { Typography, Paper, Chip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'
import './checks.scss'
import { RiskLevel } from '../../../../../components/utilities/RiskLevel'
import MapStaticComponent from '../../../../../components/common/googleMaps/GoogleMapsStaticComponent'
import CheckDetailTitle from './CheckDetailTitle'

const CheckBlacklists = ({ check, level = 0 }) => {
  const { t } = useTranslation(['common'])

  const lists = useMemo(() => {
    const documents = []

    if (check.checkDetails?.cnpjBlocklist && check.checkDetails.cnpjBlocklist.found !== false && check.checkDetails.cnpjBlocklist.documentNumber) {
      documents.push({
        ...check.checkDetails?.cnpjBlocklist,
        type: 'CNPJ',
      })
    }

    if (Array.isArray(check?.checkDetails?.cpfBlocklist) && check.checkDetails.cpfBlocklist.length > 0) {
      check?.checkDetails?.cpfBlocklist?.forEach((item) =>
        documents.push({
          ...item,
          type: item.type || 'CPF',
        }),
      )
    }

    if (
      check.type === 'BLACKLISTS_PERSON' &&
      check.checkDetails &&
      check.checkDetails.found !== false &&
      check.checkDetails.documentNumber &&
      !check.checkDetails.cnpjBlocklist &&
      !check.checkDetails.cpfBlocklist
    ) {
      documents.push({
        ...check.checkDetails,
        type: check.checkDetails.type || 'CPF',
      })
    }

    return documents
  }, [check.checkDetails, check.type])

  const hasChecks = lists.length > 0

  const riskLevelLabel = (string) => {
    const levels = [
      { key: 'very high', value: 'VERY_HIGH' },
      { key: 'high', value: 'HIGH' },
      { key: 'medium', value: 'MEDIUM' },
      { key: 'low', value: 'LOW' },
    ]
    const found = levels.find((l) => string.toLowerCase().includes(l.key))
    return found ? found.value : string
  }

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:blacklists')}</Typography>
        <CheckRiskStatus checkLength={lists.length} hasChecks={hasChecks} />
      </Paper>

      <CheckDetailTitle
        email={check.email}
        status={check.status}
        createdAt={check.createdAt}
        updatedAt={check.updatedAt}
      />

      {hasChecks &&
        lists?.map((element, index) => (
          <TimelineDotLine key={index}>
            <Paper elevation={0} variant="rootOutlined" sx={{ flex: 1 }}>
              <div className="c-detail-grid">
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:type')}</Typography>
                  <Typography variant="subtitle3">{element.type ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:documentNumber')}</Typography>
                  <Typography variant="subtitle3">{element.documentNumber ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:name')}</Typography>
                  <Typography variant="subtitle3">{element.name ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:description')}</Typography>
                  <Typography variant="subtitle3">{element.description ?? '---'}</Typography>
                </div>
                {element.type === 'CNPJ' && (
                  <div style={{ gridColumn: '1 / 3' }}>
                    <div className="c-detail-row" style={{ marginBottom: '1rem' }}>
                      <Typography variant="subtitle1">{t('common:address')}</Typography>
                      <Typography variant="subtitle3">{element.address ?? '---'}</Typography>
                    </div>
                    {element.address ? (
                      <div className="c-detail-row">
                        <MapStaticComponent
                          fixedAddress={element.address}
                          height={300}
                          width={450}
                          borderRadius={2}
                        />
                        <MapStaticComponent
                          fixedAddress={element.address}
                          height={300}
                          width={450}
                          borderRadius={2}
                          showStreetView
                        />
                      </div>
                    ) : (
                      '---'
                    )}
                  </div>
                )}
                {element.type === 'CPF' && (
                  <>
                    <div className="c-detail-row">
                      <Typography variant="subtitle1">{t('common:riskLevel')}</Typography>
                      <Typography variant="subtitle3">
                        {element.riskLevel ? <RiskLevel type={riskLevelLabel(element.riskLevel)} /> : '---'}
                      </Typography>
                    </div>
                    <div className="c-detail-row">
                      <Typography variant="subtitle1">{t('common:isPep')}</Typography>
                      <Typography variant="subtitle3">
                        {element.isPep ? (
                          <Chip
                            size="small"
                            style={{ backgroundColor: element.isPep.includes('No') ? '#c0cec4' : '#ffd7d4' }}
                            label={element.isPep.includes('No') ? t('common:isNotPEP') : t('common:isCurrentlyPep')}
                          />
                        ) : (
                          '---'
                        )}
                      </Typography>
                    </div>
                    <div className="c-detail-row">
                      <Typography variant="subtitle1">{t('common:relatedCompany')}</Typography>
                      <Typography variant="subtitle3">{element.relatedCompany ?? '---'}</Typography>
                    </div>
                  </>
                )}
              </div>
            </Paper>
          </TimelineDotLine>
        ))}
    </>
  )
}

export default CheckBlacklists
